import { Component } from '@angular/core';

@Component({
    selector: 'clients-grid-container',
    template: `
        <div class="flex flex-col items-stretch gap-5 xs:gap-0">
            <ng-content></ng-content>
        </div>
    `
})
export class ContainerComponent {
    constructor() {}
}
